import { render, staticRenderFns } from "./VersionsPopup.vue?vue&type=template&id=0d3409d4&class=versions-layout&"
import script from "./VersionsPopup.vue?vue&type=script&lang=ts&"
export * from "./VersionsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./VersionsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VCardTitle,VCol,VRow,VSimpleTable,VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3409d4')) {
      api.createRecord('0d3409d4', component.options)
    } else {
      api.reload('0d3409d4', component.options)
    }
    module.hot.accept("./VersionsPopup.vue?vue&type=template&id=0d3409d4&class=versions-layout&", function () {
      api.rerender('0d3409d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/portefeuille/VersionsPopup.vue"
export default component.exports